import React, {useEffect, useRef} from 'react';
import {Portal} from '@unthinkable/react-portal';
import {useIsMounted} from '@unthinkable/react-utils';
import {Styled, View} from '@unthinkable/react-core-components';
import theme from '../../theme/Theme';
import {useNavigate} from 'react-router-dom';

// Slide-in animation with CSS
const StyledSliderContainer = Styled(View)`
  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(300px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: ${({width}) => width || '400px'};
  background-color: ${theme.colors.BACKGROUND};
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  animation: fadeInRight 0.3s ease-out;
  z-index: 1000;
`;

const StyledBackdrop = Styled(View)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
`;

const SliderPanel = ({isVisible, children, style, width}) => {
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const containerRef = useRef(null);

  const handleOutsideClick = e => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      navigate(-1); // close panel via router navigation
    }
  };

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isVisible]);

  useEffect(() => {
    if (isMounted() && !isVisible) {
      navigate(-1);
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <Portal>
      <StyledBackdrop />
      <StyledSliderContainer
        ref={containerRef}
        style={style}
        width={width}
        className={isVisible ? 'visible' : ''}>
        {children}
      </StyledSliderContainer>
    </Portal>
  );
};

export default SliderPanel;
